export default {
  title: 'Magazinul Evenimentului',
  productPage: 'Pagina produsului',
  qty: 'Cant.',
  button: {
    edit: 'Modifică',
    add: 'Adaugă în Coș',
  },
};
